<template>
  <div class="c_blog_filter_result" :class="[`c_blog_filter_result--${layout}`, `c_blog_filter_result--${entryType}`]">
    <Button
      class="c_blog_filter_result__image"
      :class="insetImage ? 'c_blog_filter_result__image--inset' : ''"
      :href="entry.url"
    >
      <ImageInfoOverlay class="c_box--mask c_blog_filter_result__image_ratio">
        <MediaImage
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
          "
          background
          :alt="entry.metaImage[0].title"
          :sources="[
            {
              srcset: layout === 'list' ? entry.metaImage[0].square?.srcsetWebp : entry.metaImage[0].square?.srcsetWebp,
              type: 'image/webp',
            },
            {
              srcset: layout === 'list' ? entry.metaImage[0].square?.srcset : entry.metaImage[0].square?.srcset,
            },
          ]"
          v-if="entry.metaImage?.length"
        />
      </ImageInfoOverlay>
      <div class="c_blog_filter_result__thumb_date" v-if="entry.thumbDateMonth && entry.thumbDateDate">
        <div class="c_blog_filter_result__thumb_date__date">{{ entry.thumbDateDate }}</div>
        <div class="c_blog_filter_result__thumb_date__month">{{ entry.thumbDateMonth }}</div>
      </div>
    </Button>
    <div class="c_blog_filter_result__info c_blog_filter_result__detail_container">
      <div v-if="entry.typeHandle === 'customerStory'">
        <div class="c_blog_filter_result__post_date">
          <span>{{ entry.title }}</span>
          <span id="read_time">{{ generateReadTime }} min read</span>
        </div>
        <Button class="c_blog_filter_result__title" :href="entry.url">
          <h3 v-html="entry.customerStoryContent[0].leadParagraph" />
          <!-- <h3>{{ entry.title }}</h3> -->
          <!--{{ removeBR(entry.title) }}-->
        </Button>
      </div>
      <div v-else>
        <div class="c_blog_filter_result__post_date" v-if="formattedPostDate || generateReadTime">
          <span>{{ formattedPostDate }}</span>
          <span id="read_time">{{ generateReadTime }} min read</span>
        </div>
        <Button class="c_blog_filter_result__title" :href="entry.url" v-if="entry.title">
          <h3 v-html="entry.title" />
          <!-- <h3>{{ entry.title }}</h3> -->
          <!--{{ removeBR(entry.title) }}-->
        </Button>
      </div>

      <div class="c_blog_filter_result__description c_text" v-if="entry.metaDescription">
        <p>{{ entry.metaDescription }}</p>
      </div>
      <div class="c_blog_filter_result__description c_text" v-if="formattedDisplayTime">
        <p>
          <span v-html="formattedDisplayTime"></span>
        </p>
      </div>
      <div class="c_blog_filter_result__description c_text" v-if="entry.location">
        <p>{{ entry.location }}</p>
      </div>
      <div class="c_blog_filter_result__description c_text" v-if="entry.price">
        <p>{{ entry.price }}</p>
      </div>
    </div>
    <div
      class="c_blog_filter_result__ctas c_blog_filter_result__detail_container"
      v-if="['product', 'event'].includes(entryType)"
    >
      <div
        class="c_blog_filter_result__icons_wrapper"
        v-if="['product'].includes(entryType) ? entry.icons?.length : false"
      >
        <span>{{ $t('Application') }}</span>
        <div class="c_blog_filter_result__icons">
          <MediaImage
            :alt="icon.title"
            :sources="[{ src: icon.url, width: icon.width, height: icon.height }]"
            v-for="(icon, index) in entry.icons"
            :key="index"
          />
        </div>
      </div>
      <div class="c_blog_filter_result__buttons" v-if="['product'].includes(entryType)">
        <AssetButton
          class="c_button c_button--pointer c_button--small c_button--reset c_asset_category_button"
          :label-text="entry.featuredAsset[0].title"
          :href="entry.featuredAsset[0].url"
          theme="red"
          style="
            --asset-button-font-size: 12.8px;
            font-family: Graphik-Semibold, Helvetica, Arial, sans-serif;
            font-weight: normal;
            font-style: normal;
            margin-bottom: 1px;
            width: 325px;
            border-color: red;
            border-style: solid;
            color: black;
          "
          v-if="['product'].includes(entryType) ? entry.featuredAsset?.length : false"
        />
        <!-- button button--submit c_button c_button--pointer c_button--small -->
        <!-- font-family: "Graphik-Semibold", Helvetica, Arial, sans-serif;
    font-weight: normal;
    font-style: normal; -->

        <span v-else></span>
        <Button
          class="c_blog_filter_result__buttons__button"
          outline
          small
          color="gray_112"
          :aria-label="`${$t('Specifications for')} ${entry.title}`"
          :label-text="$t('Specifications')"
          :href="entry.specificationsTab[0].url"
          v-if="['product'].includes(entryType) ? entry.specificationsTab?.length : false"
        />
        <span v-else></span>
        <Button
          v-if="!hidePrimaryButton"
          class="button button--submit"
          small
          :aria-label="`${$t('Learn more about')} ${entry.title}`"
          :label-text="$t('Learn more')"
          :href="entry.url"
        />
      </div>
      <div
        class="c_blog_filter_result__buttons c_blog_filter_result__buttons--columns"
        v-if="['event'].includes(entryType)"
      >
        <Button
          v-if="!hidePrimaryButton"
          class="c_blog_filter_result__buttons__button"
          outline
          small
          color="gray_112"
          :aria-label="`${$t('Learn more about')} ${entry.title}`"
          :label-text="$t('Learn more')"
          :href="entry.url"
        />
        <Button
          class="c_blog_filter_result__buttons__button"
          small
          :aria-label="
            entry.eventRegistrationLabel ? entry.eventRegistrationLabel : `${$t('Register for')} ${entry.title}`
          "
          :label-text="entry.eventRegistrationLabel ? entry.eventRegistrationLabel : $t('Register')"
          :href="entry.eventRegistrationUrl"
          :new-window="true"
          v-if="['event'].includes(entryType) ? entry.eventRegistrationUrl : false"
        />
        <span v-else></span>
      </div>
    </div>
  </div>
</template>

<script>
import AssetButton from 'Components/New_FilterP/AssetButton.vue';
import Button from 'Components/button/Button.vue';
import ImageInfoOverlay from 'Components/image_info_overlay/ImageInfoOverlay.vue';
import MediaImage from 'Components/image/MediaImage.vue';
import { translatePostDate } from 'JS/global.js';

export default {
  components: {
    AssetButton,
    Button,
    ImageInfoOverlay,
    MediaImage,
  },
  data() {
    return {};
  },
  props: {
    entry: Object,
    entryType: { type: String, required: true }, // blog, events, news, product
    insetImage: {
      type: Boolean,
      default: false,
    },
    hidePrimaryButton: {
      type: Boolean,
      default: false,
    },
    layout: String, // list, tile
    secondaryButton: Object,
  },
  methods: {
    removeBR(text) {
      return text.replace(/<br\/>|<br>|<br \/>/g, '');
    },
  },
  computed: {
    formattedPostDate() {
      return translatePostDate(this.entry?.entryPostDate, this.$i18n?.locale);
    },
    formattedDateTimeCopy() {
      switch (this.entry?.dateAndTimeDisplay) {
        case '1':
          return `${this.$t('Date')}`;
        case '2':
          return null;
        default:
          return `${this.$t('Date and')} <br> ${this.$t('Time')}`;
      }
    },
    formattedLocaleTime() {
      switch (this.$i18n.locale) {
        case 'ja':
          return 'ja-JP';
        case 'ko':
          return 'ko-KR';
        case 'zh':
          return 'zh-CN';
        default:
          return 'en-US';
      }
    },
    formattedDisplayTime() {
      const startUTC = this.entry?.startDate ? new Date(this.entry?.startDate) : null;
      const endUTC = this.entry?.endDate ? new Date(this.entry?.endDate) : null;
      const timezoneUTC = this.entry?.eventTimezone || null;
      const timezone = this.entry?.timezone || null;
      const formatDate = { month: 'long', day: 'numeric', timeZone: timezoneUTC };
      const formatTime = { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: timezoneUTC };
      const startDate = startUTC
        ? new Intl.DateTimeFormat(this.formattedLocaleTime, formatDate).format(startUTC)
        : null;
      const startTime =
        startUTC && timezoneUTC ? new Intl.DateTimeFormat(this.formattedLocaleTime, formatTime).format(startUTC) : null;
      const endDate = endUTC ? new Intl.DateTimeFormat(this.formattedLocaleTime, formatDate).format(endUTC) : null;
      const endTime =
        endUTC && timezoneUTC ? new Intl.DateTimeFormat(this.formattedLocaleTime, formatTime).format(endUTC) : null;
      if (startDate) {
        switch (this.entry?.dateAndTimeDisplay) {
          case '1': // date only
            if (endDate && endDate !== startDate) {
              return `${startDate} - ${endDate}`;
            } else {
              return `${startDate}`;
            }
          case '2': // hide date and time
            return null;
          default:
            if (endDate && endDate !== startDate) {
              return `${startDate}, ${startTime} - ${endDate}, ${endTime} ${timezone}`;
            } else if (endTime) {
              return `${startDate}, ${startTime} - ${endTime} ${timezone}`;
            } else {
              return `${startDate}, ${startTime}`;
            }
        }
      } else {
        return null;
      }
    },
    generateReadTime() {
      let words = '';
      let content = '';
      if (this.entry.typeHandle === 'customerStory') {
        content = this.entry.customerStoryContent;
      } else {
        content = this.entry.blogContent;
      }
      content.forEach((paragraph) => {
        words += ' ' + paragraph.text;
      });
      const wordsFormatted = words.replace(/<[^>]+>/g, '');
      const numOfWords = wordsFormatted.split(' ').length;
      const time = Math.ceil(numOfWords / 225);
      return time;
    },
  },
};
</script>

<style lang="scss">
.button {
  padding: 1rem 1.5rem;
  // width: 225px;
  border-radius: 10px;
  align-self: center;
}

.c_page_header {
  flex-flow: wrap;
}

.c_image_info_overlay__overlay {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.c_blog_filter_result {
  $self: &;
  $_padding: 17px;
  $_padding: 0px;

  display: grid;
  grid-gap: 32px;
  padding: $_padding;
  position: relative;

  border-bottom: 8px solid $color_yellow;

  @media screen and (max-width: 800px) {
    grid-gap: 15px;
  }

  @at-root #{$self}__image_ratio_container {
    position: relative;
    .c_image_bg {
      position: absolute;
    }
  }
  // @at-root #{$self}__detail_container {
  //   padding-left: 15px;
  //   padding-right: 15px;
  // }
  @at-root #{$self}__image_ratio {
    @include aspect-ratio(100, 72);
  }

  @at-root #{$self}--tile {
    grid-template-rows: auto 1fr auto;

    @at-root #{&}#{$self}--product {
      // min-height: 400px;
      height: auto;
      border-radius: 15px;

      /* grid-template-rows: 100px 1fr auto; */
    }
  }
  @at-root #{$self}--list {
    grid-template-columns: 240px auto;
    grid-template-rows: 1fr auto;
    grid-gap: $_padding;
    grid-template-areas:
      'image info'
      'image buttons';
    margin-bottom: 21px;
    height: 240px;
  }

  @at-root #{$self}__image {
    @at-root #{$self}--list & {
      grid-area: image;
      padding: 15px;
    }
    @at-root #{$self}--tile & {
      @at-root #{&}--inset {
        margin-top: 0;
        margin-left: 0;
        width: 100%;
        #{$self}__thumb_date {
          padding: #{$_padding * 2};
        }
      }
    }
  }
  @at-root #{$self}__thumb_date {
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-template-areas:
      'month month'
      'date suffix';
    align-items: end;
    padding: px_to_rem(20);
    position: absolute;
    top: 0;
    left: 0;
    text-transform: uppercase;
    @include font('graphik_semibold');
    line-height: 1;
    color: $color_white;

    @at-root #{&}__month {
      grid-area: month;
      font-size: 1.1rem;
    }
    @at-root #{&}__date {
      grid-area: date;
      font-size: 2.9rem;
    }
    @at-root #{&}__suffix {
      grid-area: suffix;
      font-size: 1.2rem;
      transform: translateY(-0.25em);
    }
  }
  @at-root #{$self}__info {
    @at-root #{$self}--list & {
      grid-area: info;
    }
    @at-root #{$self}--tile & {
      grid-column: 1;
      grid-row: 2;
    }

    @at-root #{$self}__title {
      display: block;
      @include font('graphik_bold');
      line-height: 1.1;
      text-decoration: none;
      width: 100%;
      color: $color_black;
      &:hover,
      &:focus {
        color: $color_red;
      }

      @at-root #{$self}--list & {
        margin-bottom: 0.5em;
        font-size: 1.46rem;
      }
      @at-root #{$self}--tile & {
        margin-bottom: 0.3em;
        // font-size: 24px;
        font-size: 1.2rem;
        height: 100%;
        // @media screen and (max-width: 800px) {
        //   font-size: 27px;
        // }
      }
    }
    @at-root #{$self}__post_date {
      margin-bottom: 0.7rem;
      // font-size: 13.5px;
      font-size: 0.9rem;
      color: $color_gray_86;
      display: flex;
      justify-content: space-between;
      @include font('graphik_regular');
      @media screen and (max-width: 800px) {
        #read_time {
          display: none;
        }
        @include font('graphik_semibold');
        color: $color_black;
      }
    }
    @at-root #{$self}__description {
      --text-fz: 1rem;
      width: 90%;
      margin: 0 auto;
      padding-left: 5px;
    }
  }
  @at-root #{$self}__ctas {
    @at-root #{$self}--tile & {
      grid-column: 1;
      grid-row: 3;
    }
  }
  @at-root #{$self}__buttons {
    --button-small-px: 3px;
    display: grid;
    @at-root #{$self}__buttons__button {
      padding-left: 10px;
      padding-right: 10px;
    }

    @at-root .app--isEdge15orDown & {
      display: flex;
      flex-flow: row wrap;
    }

    @at-root #{$self}--list & {
      grid-area: buttons;
      grid-template-columns: auto max-content max-content;
      gap: 20px;
      align-items: flex-end;

      & > * {
        max-width: 300px;
      }
    }
    @at-root #{$self}--tile & {
      grid-template-columns: minmax(auto, 300px);
      gap: 14px;
      justify-content: center;

      @include mq($mq_md_to_lg) {
        gap: 7px;
      }
      @include mq(1150) {
        gap: 14px;
      }

      @at-root #{&}--columns {
        grid-template-columns: repeat(2, 1fr);
        @include mq($mq_md_to_lg) {
          grid-template-columns: 1fr;
        }
        @include mq(1150) {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
  @at-root #{$self}__icons_wrapper {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 13px;
    align-items: center;
    margin-bottom: 14px;
    font-size: 1.15rem;

    @at-root .app--isEdge15orDown & {
      display: flex;
      flex-flow: row wrap;
    }

    @at-root #{$self}--list & {
      margin-bottom: 16px;
    }
    @at-root #{$self}--tile & {
      margin-bottom: 14px;
    }
  }
  @at-root #{$self}__icons {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(15px, 20px));
    grid-template-rows: minmax(min-content, 25px);
    gap: 8px;
    align-items: center;
    justify-content: flex-start;

    @at-root .app--isEdge15orDown & {
      display: flex;
      flex-flow: row wrap;
    }
  }
}
</style>
